import { appstr } from "@coreapp/utils/appstr";
import { enumObjClassNames, enumObjectTypes } from "@coreapp/constants";
import { getAllSystemGeneratedFieldNames } from "@/appComponents/Blocks/Cards/ProfileBaseballCard/SystemGeneratedFieldPill";
import {
  ChartSettingsSectionRoutes,
  getChartSettingsTestPrefix
} from "@/providers/NavigationProvider";

export const SUBCHARTS_TEST_PREFIX = getChartSettingsTestPrefix(
  ChartSettingsSectionRoutes.Subcharts
);

//option constants
export const SubChartBreakOptions = {
  autobreaks: 0,
  breakbylevel: 1,
  breakbyfield: 2
};

export const StartBreaksOptions = [
  {
    label: appstr("Level 2"),
    value: "2"
  },
  {
    label: appstr("Level 3"),
    value: "3"
  },
  {
    label: appstr("Level 4"),
    value: "4"
  }
];

export const PageDensityOptions = [
  {
    label: appstr("Standard"),
    value: "0"
  },
  {
    label: appstr("Dense"),
    value: "1"
  },
  {
    label: appstr("pageverydense"),
    value: "2"
  }
];

//build list props
export const BuildFieldOptions = (headers, changeFunction) => {
  let options = [];
  for (let idx in headers) {
    options.push({
      label: headers[idx],
      value: headers[idx],
      clickHandler: changeFunction
    });
  }

  return options;
};
export const getSubchartHiddenFields = (chartConfig, onlyFromType) => {
  const staticNames = chartConfig?.formulas?.map(f => f.name) ?? [];
  const scriptNames = chartConfig?.scriptFormulas?.map(f => f.formulaName) ?? [];
  const allNames = [
    ...new Set([
      ...staticNames,
      ...scriptNames,
      ...getAllSystemGeneratedFieldNames(chartConfig?.fields)
    ])
  ];

  let classNames;
  if (onlyFromType === enumObjectTypes.position) {
    classNames = [enumObjClassNames.position];
  } else if (onlyFromType === enumObjectTypes.holder) {
    classNames = [enumObjClassNames.box];
  } else {
    classNames = [enumObjClassNames.box, enumObjClassNames.position];
  }

  return allNames.flatMap(name => classNames.map(cls => `${cls}-${name}`));
};

// add onchange to constants
export const BuildSelectProps = (options, changeFunction) => {
  let selectOptions;
  return (selectOptions = options.map(option => ({
    ...option,
    clickHandler: changeFunction
  })));
};
